import * as pageStyles from '../../styles/internal-page/fil-ariane.module.scss';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import { Link } from 'gatsby';
import clsx from 'clsx';

const separator = (idx, isLastElement) => {
  if (idx !== 0) {
    return (
      <span
        className={clsx(pageStyles.separator, {
          [pageStyles.lastElementStyle]: isLastElement,
        })}
      >
        {'>'}
      </span>
    );
  }
  return null;
};

const toFilArianeElement = (element, isLastElement, lang) => {
  let displayLang = '';
  if (lang) {
    displayLang = lang.toLowerCase();
  }

  if (isLastElement) {
    return (
      <span
        className={clsx(pageStyles.typoAriane, pageStyles.lastElementStyle)}
        lang={displayLang}
      >
        {element.label}
      </span>
    );
  }

  if (element.navigationPath) {
    return (
      <Link className={pageStyles.linkStyle}
        to={element.navigationPath}
      >
        {element.label}
      </Link>
    );
  }

  return <span className={pageStyles.typoAriane}>{element.label}</span>;
};

const isLastArrayEl = (idx, arr) => {
  return idx === arr.length - 1;
};

const FilAriane = React.memo(function FilAriane ({ ariane, lang }) {
  return (
    <p className={pageStyles.rootAriane}>
      {ariane?.map((element, index, arr) => {
        return (
          <Fragment key={index}>
            {separator(index, isLastArrayEl(index, arr))}
            {toFilArianeElement(element, isLastArrayEl(index, arr), lang)}
          </Fragment>
        );
      })}
    </p>
  );
});

FilAriane.propTypes = {
  ariane: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      navigationPath: PropTypes.string,
    })
  ),
  lang: PropTypes.string,
  url: PropTypes.string,
};

export default FilAriane;
